import "./index.scss";
import { useContext, useEffect, useRef, useState } from "react";
import Stopwatch from "../../components/Stopwatch";
import { post, useGet, usePost } from "../../api/request";
import GlobalError from "../../components/GlobalError";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../redux/auth";
import { setIsReadyToWork, triggerStatsUpdate, setIsPaused as setIsPausedRedux } from "../../redux/work";
import StopwatchStorage from "../../api/StopwatchStorage";
import { useAlert } from "../../components/AlertNotification";
import StopwatchTextarea from "../../components/StopwatchTextarea";
import { ActionContext } from "../../context/actionContext";
import { Button } from "@mui/material";

const TimerSection = () => {
  const { action, setAction } = useContext(ActionContext);
  const postU = usePost();
  const getU = useGet()
  const alertU = useAlert();

  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  
  const [count, setCount] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [inactivityWarningModal, setInactivityWarningModal] = useState(false);
  const isPaused = useSelector(state => state.work.isPaused);
  const [isDescription, setIsDescription] = useState(false);
  const [description, setDescription] = useState(null);

  const [running, setRunning] = useState(false);
  const [time, setTime] = useState(0);

  const [alert, setAlert] = useState({
    txt: "",
    isVisible: false,
  });

  const showAlert = (text) => {
    setAlert({
      txt: text,
      isVisible: true,
    });

    setTimeout(() => {
      setAlert({
        txt: text,
        isVisible: false,
      });
    }, 2500);
  };

  const [houses, setHouses] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  
  const timerRef = useRef({
    status: 'stopped',
    startedAt: 0,
    elapsed: 0,
    intervalId: null,
  });

  const lastActivityRef = useRef(Date.now());
  const inactivityTimerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const alertURef = useRef(null);

  const INACTIVITY_TIMEOUT = 60_000;
  const WARNING_TIMEOUT = 30_000;

  const updateView = (ms) => {
    const total = Math.floor(ms / 1000);
    setSeconds(total % 60);
    setMinutes(Math.floor(total / 60) % 60);
    setHouses(Math.floor(total / 3600));
  };

  const tick = () => {
    const t = timerRef.current;
    if (t.status !== 'running') return;

    const now = performance.now();
    t.elapsed += now - t.startedAt;
    t.startedAt = now;

    updateView(t.elapsed);
  };

  const startInactivityWatcher = () => {
    clearTimeout(inactivityTimerRef.current);

    inactivityTimerRef.current = setTimeout(() => {
      pause();
      setInactivityWarningModal(true);

      warningTimerRef.current = setTimeout(() => {
        setInactivityWarningModal(false);
        
        timerRef.current.elapsed = Math.max(0, timerRef.current.elapsed - INACTIVITY_TIMEOUT);
        updateView(timerRef.current.elapsed);
        
        if (alertURef.current) {
          alertURef.current({
            status: 'warning',
            title: 'Таймер на паузе',
            message: 'Таймер поставлен на паузу из-за неактивности',
          });
        }
      }, WARNING_TIMEOUT);
    }, INACTIVITY_TIMEOUT);
  };

  const start = () => {
    const isStopwatchRunning = StopwatchStorage.getIsStopwatchRunning();

    if (isStopwatchRunning) {
      alertU({
        status: "error",
        title: "Таймер уже запущен",
        message: "Остановите предыдущий таймер, перед запуском следующего.",
      });
      return;
    }

    if (timerRef.current.status !== 'stopped') return;

    timerRef.current = {
      status: 'running',
      startedAt: performance.now(),
      elapsed: 0,
      intervalId: setInterval(tick, 250),
    };

    setRunning(true);
    dispatch(setIsPausedRedux(false));
    StopwatchStorage.setIsStopwatchRunning(true);
    lastActivityRef.current = Date.now();
    startInactivityWatcher();
  };

  const pause = () => {
    const t = timerRef.current;
    if (t.status !== 'running') return;

    clearInterval(t.intervalId);
    t.status = 'paused';
    t.intervalId = null;

    dispatch(setIsPausedRedux(true));
  };

  const resume = () => {
    const t = timerRef.current;
    if (t.status !== 'paused') return;

    t.status = 'running';
    t.startedAt = performance.now();
    t.intervalId = setInterval(tick, 250);

    dispatch(setIsPausedRedux(false));
    lastActivityRef.current = Date.now();
    startInactivityWatcher();
  };

  const stop = () => {
    const t = timerRef.current;

    clearInterval(t.intervalId);
    clearTimeout(inactivityTimerRef.current);
    clearTimeout(warningTimerRef.current);

    timerRef.current = {
      status: 'stopped',
      startedAt: 0,
      elapsed: 0,
      intervalId: null,
    };

    setRunning(false);
    dispatch(setIsPausedRedux(false));
    StopwatchStorage.setIsStopwatchRunning(false);
    updateView(0);
  };

  const getElapsedMs = () => Math.floor(timerRef.current.elapsed);

  useEffect(() => {
    fetchUser()
  }, [])
  
    const fetchUser = () => {
      getU("users/current")
        .then((response) => {
          if (response.status === "success") {
      setCount(response.data.user.thisMonthPay)
      }
    }).catch(() => {
          showAlert("Произошла ошибка при получении данных о юзере");
        })
    }

  const handleSubmitTime = () => {
    const milliseconds = getElapsedMs();
    
    if(description == "")
        setDescription(null);

    postU("timetracker", { milliseconds, description })
      .then((response) => {
        if (response.status === "success") {
          dispatch(
            setUser({
              ...user,
              thisMonthPay: response.data.timeTrack.thisMonthPay,
            })
          );
          setCount(response.data.timeTrack.thisMonthPay);
          alertU({
            status: 'success',
            title: 'Сохранение времени',
            message: 'Ваши данные были успешно сохранены'
        });
          setTime(0);
          setAction(false);
          dispatch(triggerStatsUpdate());
          stop();
        }
      })
      .catch(() => {
        showAlert("Произошла ошибка при попытке остановить время");
      });

    setDescription(null);
    setIsDescription(false);
  }

  useEffect(() => {
    alertURef.current = alertU;
  }, [alertU]);

  const finish = () => {
    if(!action && !description) {
  
    setModalIsOpen(true)
    return null
    } else {
      handleSubmitTime()

    }

  };


  const onBeforeUnload = (e) => {
    StopwatchStorage.setIsStopwatchRunning(false);
    if (!running) {
      return;
    }
    var dialogText =
      "Закрыть сайт? Возможно, внесенные изменения не сохранятся.";
    e.returnValue = dialogText;
    return dialogText;
  };

  const handleChangeDescription = (evt) => {
    setDescription(evt.target.value);
  };

  useEffect(() => {
    window.onbeforeunload = onBeforeUnload;
    if (running) {
      dispatch(setIsReadyToWork(true));
    } else {
      dispatch(setIsReadyToWork(false));
    }
  }, [running]);

  const registerActivity = () => {
    if (timerRef.current.status !== 'running') return;
    if (inactivityWarningModal) return;

    lastActivityRef.current = Date.now();
    clearTimeout(inactivityTimerRef.current);
    clearTimeout(warningTimerRef.current);
    startInactivityWatcher();
  };

  const handleWarningContinue = () => {
    clearTimeout(warningTimerRef.current);
    setInactivityWarningModal(false);
    resume();
  };

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

    events.forEach(e => window.addEventListener(e, registerActivity));
    return () => events.forEach(e => window.removeEventListener(e, registerActivity));
  }, [inactivityWarningModal]);

  return (
 
    <div className="timer-section">
      <div className="timer-section__timer-block">
        <div
          className="timer-section__timer-block-icon"
          style={{ display: running && !isPaused ? "none" : "flex" }}
          onClick={() => {
            if (isPaused) {
              resume();
            } else {
              start();
            }
          }}
        >
          <img src="/img/startTimer.png" alt="img" />
        </div>
        <div
          className="timer-section__timer-block-icon"
          style={{ display: running && !isPaused ? "flex" : "none" }}
          onClick={() => {
            finish();
          }}
        >
          <img src="/img/stopTimer.png" alt="img" />
        </div>
        <div className="timer-section__timer-block-timer">
          <Stopwatch
            running={running}
            houses={houses}
            minutes={minutes}
            seconds={seconds}
          />
          {isPaused && (
            <span style={{marginLeft: '10px', color: '#FFC75A', fontSize: '14px'}}>(Пауза)</span>
          )}
        </div>
      </div>
      {running && (
        <div className="timer-section__description-block">
          {!isDescription ? (
            <div className="timer-section__button">
              <button
                className="main__form__buttons-save"
                onClick={() => {
                  setIsDescription(true);
                }}
              >
                Добавить описание
              </button>
            </div>
          ) : (
            <StopwatchTextarea onChange={handleChangeDescription} />
          )}
        </div>
  
      )}
      {alert.isVisible && (
        <GlobalError isVisible={alert.isVisible}>{alert.txt}</GlobalError>
      )}

{modalIsOpen && (
  <div className="confirm-modal">
    <h3 className="modal-heading">Не видно, что было сделано за это время. Хотите отменить таймер?</h3>
    <div className="btn-container-modal">
      <Button color="primary" onClick={() => {
        stop();
        setModalIsOpen(false);
      }}>Да</Button>
      <Button onClick={() => setModalIsOpen(false)}>Нет</Button>
    </div> 
  </div>
)}
{inactivityWarningModal && (
  <div className="confirm-status active">
    <div className="confirm-status__content active" onClick={e => e.stopPropagation()}>
      <div className="confirm-status__content-title">
        Предупреждение
      </div>
      <div className="confirm-status__content-desc">
        Через {WARNING_TIMEOUT / 1000} секунд таймер будет остановлен из-за неактивности. Нажмите "Я тут", чтобы продолжить работу.
      </div>
      <div className="confirm-status__content-buttons">
        <button className="main__form__buttons-save" onClick={handleWarningContinue}>
          Я тут
        </button>
      </div>
    </div>
  </div>
)}
    </div>

  );
};

export default TimerSection;
